module.exports = "<div>{{$ctrl.view}}</div>"


//////////////////
// WEBPACK FOOTER
// ../widgets/date-time-view/date-time-view.html
// module id = 747
// module chunks = 0